import { callAPI } from "../network/networkConnection";
import { NetworkConfiguration } from "../network/networkConfriguation";

const base = process.env.REACT_APP_APIUrl;

const getDashboard = () =>
  callAPI(base + NetworkConfiguration.AFFILIATE_DASHBOARD, "GET", { "Content-Type": "application/json" }, null);

const getSellers = (params = {}) => {
  const q = new URLSearchParams(params).toString();
  const url = q ? `${base}${NetworkConfiguration.AFFILIATE_SELLERS}?${q}` : base + NetworkConfiguration.AFFILIATE_SELLERS;
  return callAPI(url, "GET", { "Content-Type": "application/json" }, null);
};

const getSellerOrders = (sellerId) =>
  callAPI(
    `${base}${NetworkConfiguration.AFFILIATE_SELLERS}/${encodeURIComponent(sellerId)}/orders`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );

const getEarnings = () =>
  callAPI(base + NetworkConfiguration.AFFILIATE_EARNINGS, "GET", { "Content-Type": "application/json" }, null);

const getWithdraw = () =>
  callAPI(base + NetworkConfiguration.AFFILIATE_WITHDRAW, "GET", { "Content-Type": "application/json" }, null);

const postWithdraw = (payload) =>
  callAPI(base + NetworkConfiguration.AFFILIATE_WITHDRAW, "POST", { "Content-Type": "application/json" }, JSON.stringify(payload));

const getProfile = () =>
  callAPI(base + NetworkConfiguration.AFFILIATE_PROFILE, "GET", { "Content-Type": "application/json" }, null);

const updateProfile = (payload) =>
  callAPI(base + NetworkConfiguration.AFFILIATE_PROFILE, "PUT", { "Content-Type": "application/json" }, JSON.stringify(payload));

const getSettings = () =>
  callAPI(base + NetworkConfiguration.AFFILIATE_SETTINGS, "GET", { "Content-Type": "application/json" }, null);

/** Public (no auth): program display for signup/landing */
const getProgramDisplay = () =>
  callAPI(base + NetworkConfiguration.AFFILIATE_PROGRAM_DISPLAY, "GET", { "Content-Type": "application/json" }, null);

export const AffiliateApiService = {
  getDashboard,
  getSellers,
  getSellerOrders,
  getEarnings,
  getWithdraw,
  postWithdraw,
  getProfile,
  updateProfile,
  getSettings,
  getProgramDisplay,
};
